import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";

const SelectBatchQuntity = ({ callBack, data, businessSetting, companyId, itemRows }) => {

    const [itemBatch, setItemBatch] = useState({});
    const [batchData, setBatchData] = useState([]);
    const [newBatchData, setNewBatchData] = useState([]);
    let [isLoading, setIsLoading] = useState(false);

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        console.log('data.itemBatchNo', JSON.stringify(data));
        data.selectedData = [];
        setItemBatch(data);
        let itemBatchNo = data.itemBatchNo;
        setBatchData(itemBatchNo);
        if (itemBatchNo.length == 0) {
            let newBatch = {
                batch_id: new Date().getTime() * -1,
                batch_no: '',
                model_no: '',
                exp_date: moment(new Date()).format('YYYY-MM-DD'),
                mfg_date: moment(new Date()).format('YYYY-MM-DD'),
                size: '',
                batchNoAdditionalValue1: '',
                batchNoAdditionalValue2: '',
                opening_stock: 0,
                free_quantity: 0,
                used_stock: 0,
                quantity: 0,
                isNewItem: true
            };
            setNewBatchData([...newBatchData, newBatch]);
        }

    }, []);

    const getInStock = (element) => {
        let freeQuantity = element.free_quantity ? parseInt(element.free_quantity) : 0;
        let usedQuantity = element.used_stock ? parseInt(element.used_stock) : 0;
        let stock = element.opening_stock - (freeQuantity + usedQuantity);
        return stock;
    }

    const addNewBatchData = async() => {
        const hasEmptyValues = newBatchData.some(obj =>
            (businessSetting.BatchNoChk == 1 && !obj.batch_no) ||
            (businessSetting.ModelNoChk == 1 && !obj.model_no) ||
            (businessSetting.ExpDateChk == 1 && !obj.exp_date) ||
            (businessSetting.MfgDateChk == 1 && !obj.mfg_date) ||
            (businessSetting.SizeChk == 1 && !obj.size) ||
            (businessSetting.BatchNoAdditionalChk1 == 1 && !obj.batchNoAdditionalValue1) ||
            (businessSetting.BatchNoAdditionalChk2 == 1 && !obj.batchNoAdditionalValue2) ||
            (!obj.used_stock)
        );
        if (hasEmptyValues) {
            alert('Some values have empty of new added batch.');
            return;
        } 
        
        let newBatch = {
            batch_id: new Date().getTime() * -1,
            batch_no: '',
            model_no: '',
            exp_date: moment(new Date()).format('YYYY-MM-DD'),
            mfg_date: moment(new Date()).format('YYYY-MM-DD'),
            size: '',
            batchNoAdditionalValue1: '',
            batchNoAdditionalValue2: '',
            opening_stock: 0,
            free_quantity: 0,
            used_stock: 0,
            quantity: 0,
            isNewItem: true
        };
        setNewBatchData([...newBatchData, newBatch]);
    }
    const deleteBatchData = (index) => {
        let updatedBatchData = [...newBatchData];
        updatedBatchData.splice(index, 1);
        setNewBatchData(updatedBatchData);
    }
    const saveBatchData = async (batch) => {
        batch.free_quantity = batch.free_quantity ? batch.free_quantity : 0;
        const hasEmptyValues = newBatchData.some(obj =>
            (businessSetting.BatchNoChk == 1 && !obj.batch_no) ||
            (businessSetting.ModelNoChk == 1 && !obj.model_no) ||
            (businessSetting.ExpDateChk == 1 && !obj.exp_date) ||
            (businessSetting.MfgDateChk == 1 && !obj.mfg_date) ||
            (businessSetting.SizeChk == 1 && !obj.size) ||
            (businessSetting.BatchNoAdditionalChk1 == 1 && !obj.batchNoAdditionalValue1) ||
            (businessSetting.BatchNoAdditionalChk2 == 1 && !obj.batchNoAdditionalValue2) ||
            (!obj.used_stock)
        );
        if (hasEmptyValues) {
            alert('Some values have empty of new added batch.');
            return;
        } 
        let _batchData = [...batchData, ...newBatchData];
        const allBatchNo = _batchData.filter((data) => data.batch_no).map((data) => data.batch_no);

        const counts = allBatchNo.reduce((acc, num) => {
            acc[num] = (acc[num] || 0) + 1;
            return acc;
          }, {});
        const duplicatesData = Object.keys(counts).filter(num => counts[num] > 1);
        if (duplicatesData.length > 0) {
            alert("The batch numbers ("+duplicatesData+") already exist in the system. Please try another batch number.");
            return;
        }
        const itemRowsBatchNo = itemRows.map((data) => data.selectedData).map((data) => data.filter((data) => data.batch_no).map((data) => data.batch_no));
        const duplicateItemRowsBatchNo = itemRowsBatchNo.flat().filter(item => item !== "");
        const isExitsBatchNos = duplicateItemRowsBatchNo.some(item => allBatchNo.includes(item));
        const meargeBatchNo = [...allBatchNo, ...duplicateItemRowsBatchNo];
        const uniqueBatchNos = [...new Set(meargeBatchNo)];
        if (isExitsBatchNos) {
            alert("The batch numbers ("+uniqueBatchNos+") already exist in the system. Please try another batch number.");
            return;
        }
        const allNewBatchNo = _batchData.filter((data) => data.batch_no && data.batch_id < 1).map((data) => data.batch_no);
        let duplicates = {success: false};
        if(allNewBatchNo.length > 0){
            setIsLoading(true);
        
            const response = await fetch(global.checkBatchNo, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    allBatchNo: allNewBatchNo,
                    company_id: companyId,
                }),
              });
            duplicates = await response.json();
            
            setIsLoading(false);
        }

        const usedQty = batch.used_stock;
        const freeQty = batch.free_quantity;
        const inStock = getInStock(batch);
        console.log('usedQty', usedQty);
        if (usedQty <= 0) { 
            alert('Please enter at least one quantity.');
        } else if (inStock < 0) {
            alert('Sum of quantity and free quantity can not be greater than opening stock.');
        } else if (duplicates.success) {
            alert(duplicates.message);
        } else {
            let _itemBatchNo = itemBatch.itemBatchNo;
            let remaingBatchData = _itemBatchNo.filter((data) => data.batch_id !== batch.batch_id);
            remaingBatchData = remaingBatchData.map((data) => ({
                ...data,
                used_stock: 0,
                free_quantity: 0
            }))
            let selectedBatch = {
                ...batch,
                opening_stock: inStock,
            }

            let selectedData = [selectedBatch];
            let updatedData = {
                ...itemBatch,
                itemBatchNo: remaingBatchData,
                selectedData: selectedData,
                quantity: parseInt(usedQty),
                free_quantity: parseInt(freeQty),
                trackingType: 'Batch',
                isNewQty: selectedData.isNewItem ? 'NEW' : 'OLD'
            }
            console.log('updatedData', JSON.stringify(updatedData));

            callBack(updatedData);
        }
    }
    const handleCallBackExpireDate = (date, index) => {
        let _date = moment(date).format("YYYY-MM-DD");
        let batchData = [...newBatchData];
        batchData[index].exp_date = _date;
        setNewBatchData(batchData);
    }
    const viewExpireDate = (expireDate, index) => {
        const slectedDate = moment(expireDate).toDate();
        return (
            <DatePicker
                selected={slectedDate}
                className="form-control search-box"
                onChange={date => handleCallBackExpireDate(date, index)}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            />
        );
    }
    const handleCallBackMfgDate = (date, index) => {
        let _date = moment(date).format("YYYY-MM-DD");
        let batchData = [...newBatchData];
        batchData[index].mfg_date = _date;
        setNewBatchData(batchData);
    }
    const viewMfgDate = (mfgDate, index) => {
        const slectedDate = moment(mfgDate).toDate();
        return (
            <DatePicker
                selected={slectedDate}
                className="form-control search-box"
                onChange={date => handleCallBackMfgDate(date, index)}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            />
        );
    }

    return (
        <div className="webForm px-30" style={{ height: 300, maxHeight: 800, overflowY: 'auto', marginBottom: 20 }}>
            <div style={{ marginBottom: 20 }}>
                {batchData.map((element, index) => (
                    <div key={index}>
                        <div className="form-group row">
                            {businessSetting.BatchNoChk == 1 &&
                                <div className="col-2">
                                    <div className="open">
                                    <label htmlFor="login-username">{businessSetting.BatchNoTxt}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent", maxWidth: 160, marginBottom: 10 }}
                                            value={element.batch_no}
                                            placeholder={businessSetting.BatchNoTxt}
                                            readOnly
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            }


                            {businessSetting.ExpDateChk == 1 &&
                                <div className="col-2">
                                    <div className="open">
                                    <label htmlFor="login-username">{businessSetting.ExpDateTxt}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent" }}
                                            value={moment(element.exp_date).format('YYYY-MM-DD')}
                                            placeholder="Enter Value 2"
                                            readOnly
                                            autoComplete="off" />
                                    </div>
                                </div>
                            }

                            {businessSetting.MfgDateChk == 1 &&
                                <div className="col-2">
                                    <div className="open">
                                    <label htmlFor="login-username">{businessSetting.MfgDateTxt}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent" }}
                                            value={moment(element.mfg_date).format('YYYY-MM-DD')}
                                            placeholder="Enter Value 2"
                                            readOnly
                                            autoComplete="off" />
                                    </div>
                                </div>
                            }

                            {businessSetting.ModelNoChk == 1 &&
                                <div className="col-2">
                                    <div className="open">
                                    <label htmlFor="login-username">{businessSetting.ModelNoTxt}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent", maxWidth: 160 }}
                                            value={element.model_no ? element.model_no : 'NA'}
                                            placeholder={businessSetting.ModelNoTxt}
                                            maxLength="30"
                                            readOnly
                                            autoComplete="off" />
                                    </div>
                                </div>
                            }

                            {businessSetting.SizeChk == 1 &&
                                <div className="col-2">
                                    <div className="open">
                                    <label htmlFor="login-username">{businessSetting.SizeTxt}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent" }}
                                            value={element.size ? element.size : 0}
                                            placeholder={businessSetting.SizeTxt}
                                            readOnly
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            }

                            {businessSetting.BatchNoAdditionalChk1 == 1 &&
                                <div className="col-2">
                                    <div className=" open">
                                    <label htmlFor="login-username">{businessSetting.BatchNoAdditionalLabel1}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent", maxWidth: 160 }}
                                            value={element.batchNoAdditionalValue1 ? element.batchNoAdditionalValue1 : 'NA'}
                                            placeholder="Enter Value 1"
                                            readOnly
                                            autoComplete="off" />
                                    </div>
                                </div>
                            }
                            {businessSetting.BatchNoAdditionalChk2 == 1 &&
                                <div className="col-2" >
                                    <div className="open">
                                    <label htmlFor="login-username">{businessSetting.BatchNoAdditionalLabel2}</label><br/>
                                        <input
                                            type="text"
                                            style={{ border: 'none', outline: "none", background: "transparent", maxWidth: 160 }}
                                            value={element.batchNoAdditionalValue2 ? element.batchNoAdditionalValue2 : 'NA'}
                                            placeholder="Enter Value 2"
                                            readOnly
                                            autoComplete="off" />
                                    </div>
                                </div>
                            }
                            <div className="col-2" >
                                <div className="open">
                                <label htmlFor="login-username">Opening Stock</label><br/>
                                    <input
                                                    className="form-control"
                                        type="text"
                                        style={{ border: 'none', outline: "none", background: "transparent" }}
                                        value={element.opening_stock}
                                        placeholder="Enter Value 2"
                                        readOnly
                                        autoComplete="off" />
                                </div>
                            </div>
                            <div className="col-2" >
                                <div className="open">
                                <label htmlFor="login-username">In Stock</label><br/>
                                    <input
                                                    className="form-control"
                                        type="text"
                                        style={{ border: 'none', outline: "none", background: "transparent" }}
                                        value={getInStock(element)}
                                        placeholder="Enter Value 2"
                                        readOnly
                                        autoComplete="off" />
                                </div>
                            </div>
                            {businessSetting.FreeItemQuantity == 1 &&
                                <div className="col-2" >
                                    <div className="open">
                                    <label htmlFor="login-username">Free Quantity</label><br/>
                                        <input
                                                    className="form-control"
                                            type="text"
                                            maxLength="3"
                                            style={{ maxWidth: 160 }}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            value={element.free_quantity}
                                            placeholder="Free Quantity"
                                            onChange={e => {
                                                let value = e.target.value;
                                                value = value * 1;
                                                let updatedData = [...batchData];
                                                updatedData[index].free_quantity = value;
                                                setBatchData(updatedData);
                                            }}
                                            autoComplete="off" />
                                    </div>
                                </div>
                            }
                            <div className="col-2" >
                                <div className="open">
                                    <label htmlFor="login-username">Quantity
                                        <span className="text-danger"> * </span>
                                    </label><br/>
                                    <input
                                                    className="form-control"
                                        type="text"
                                        maxLength="3"
                                        style={{ maxWidth: 160 }}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        value={element.used_stock}
                                        placeholder="Quantity"
                                        onChange={e => {
                                            let value = e.target.value;
                                            value = value * 1;
                                            let updatedData = [...batchData];
                                            updatedData[index].used_stock = value;
                                            setBatchData(updatedData);
                                        }}
                                        autoComplete="off" />
                                </div>
                            </div>
                            <div className="col-2" >
                                <div className="open">
                                    <div className="wrapperRadio">
                                        <br/>
                                        <button
                                            type="submit"
                                            onClick={() => {
                                                saveBatchData(element);
                                            }}
                                            className="btn btn-alt-info mb-10 mx-5">
                                            Select
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ))
                }
                {
                    (batchData.length > 0 && newBatchData.length > 0) &&
                        <div
                            style={{
                                width: '100%',
                                height: '1px',
                                backgroundColor: '#e2e2e2',
                                margin: '20px 0',
                            }}
                        ></div>
                }
                {
                    newBatchData.length > 0 &&
                    <div>
                        <div style={{ marginTop: 10 }}>
                            <h5> New Batch </h5>
                        </div>
                    </div>
                }
                {
                    newBatchData.length > 0 && newBatchData.map((element, index) => {
                        return (
                            <div key={index}>
                                <div className="form-group row" style={{ border: '2px solid !important', borderColor: '#cacaca !important' }}>
                                    <div className="claerfix"></div>
                                    {businessSetting.BatchNoChk == 1 &&
                                        <div className="col-2">
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.BatchNoTxt}</label><br/>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{maxWidth: 160, marginBottom: 10}}
                                                    value={element.batch_no}
                                                    placeholder={businessSetting.BatchNoTxt}
                                                    onChange={(e) => {
                                                        let batchData = [...newBatchData];
                                                        batchData[index].batch_no = e.target.value;
                                                        setNewBatchData(batchData);
                                                    }}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                    }


                                    {businessSetting.ExpDateChk == 1 &&
                                        <div className="col-2">
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.ExpDateTxt}</label><br/>
                                                {viewExpireDate(element.exp_date, index)}
                                            </div>
                                        </div>
                                    }

                                    {businessSetting.MfgDateChk == 1 &&
                                        <div className="col-2">
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.MfgDateTxt}</label><br/>
                                                {viewMfgDate(element.mfg_date, index)}
                                            </div>
                                        </div>
                                    }

                                    {businessSetting.ModelNoChk == 1 &&
                                        <div className="col-2">
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.ModelNoTxt}</label><br/>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    style={{maxWidth: 160}}
                                                    value={element.model_no}
                                                    placeholder={businessSetting.ModelNoTxt}
                                                    maxLength="30"
                                                    onChange={(e) => {
                                                        let batchData = [...newBatchData];
                                                        batchData[index].model_no = e.target.value;
                                                        setNewBatchData(batchData);
                                                    }}
                                                    autoComplete="off" />
                                            </div>
                                        </div>
                                    }

                                    {businessSetting.SizeChk == 1 &&
                                        <div className="col-2">
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.SizeTxt}</label><br/>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    style={{maxWidth: 160}}
                                                    maxLength={3}
                                                    value={element.size}
                                                    onKeyPress={(e) => handleKeyPress(e)}
                                                    placeholder={businessSetting.SizeTxt}
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        value = value * 1;
                                                        let batchData = [...newBatchData];
                                                        batchData[index].size = value;
                                                        setNewBatchData(batchData);
                                                    }}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                    }

                                    {businessSetting.BatchNoAdditionalChk1 == 1 &&
                                        <div className="col-2">
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.BatchNoAdditionalLabel1}</label><br/>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    style={{maxWidth: 160}}
                                                    value={element.batchNoAdditionalValue1}
                                                    placeholder="Enter Value 1"
                                                    onChange={(e) => {
                                                        let batchData = [...newBatchData];
                                                        batchData[index].batchNoAdditionalValue1 = e.target.value;
                                                        setNewBatchData(batchData);
                                                    }}
                                                    autoComplete="off" />

                                            </div>
                                        </div>
                                    }
                                    {businessSetting.BatchNoAdditionalChk2 == 1 &&
                                        <div className="col-2" >
                                            <div className="open">
                                            <label htmlFor="login-username">{businessSetting.BatchNoAdditionalLabel2}</label><br/>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    style={{maxWidth: 160}}
                                                    value={element.batchNoAdditionalValue2}
                                                    placeholder="Enter Value 2"
                                                    onChange={(e) => {
                                                        let batchData = [...newBatchData];
                                                        batchData[index].batchNoAdditionalValue2 = e.target.value;
                                                        setNewBatchData(batchData);
                                                    }}
                                                    autoComplete="off" />
                                            </div>
                                        </div>
                                    }
                                    <div className="col-2" >
                                        <div className="open">
                                        <label htmlFor="login-username">Opening Stock</label><br/>
                                            <input
                                                    className="form-control"
                                                type="text"
                                                style={{  maxWidth: 160, backgroundColor: "#fff" }}
                                                value={element.opening_stock}
                                                placeholder="Enter Value 2"
                                                readOnly
                                                autoComplete="off" />
                                        </div>
                                    </div>
                                    <div className="col-2" >
                                        <div className="open">
                                        <label htmlFor="login-username">In Stock</label><br/>
                                            <input
                                                    className="form-control"
                                                type="text"
                                                style={{  maxWidth: 160, backgroundColor: "#fff" }}
                                                value={getInStock(element)}
                                                placeholder="Enter Value 2"
                                                readOnly
                                                autoComplete="off" />
                                        </div>
                                    </div>
                                    {businessSetting.FreeItemQuantity == 1 &&
                                        <div className="col-2" >
                                            <div className="open">
                                            <label htmlFor="login-username">Free Quantity</label><br/>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    maxLength={3}
                                                    style={{ maxWidth: 160 }}
                                                    onKeyPress={(e) => handleKeyPress(e)}
                                                    value={element.free_quantity}
                                                    placeholder="Free Quantity"
                                                    onChange={(e) => {
                                                        let value = e.target.value ? parseInt(e.target.value) : 0;
                                                        value = value * 1;
                                                        let batchData = [...newBatchData];
                                                        batchData[index].free_quantity = value;
                                                        batchData[index].opening_stock = parseInt(batchData[index].used_stock) + value;
                                                        setNewBatchData(batchData);
                                                    }}
                                                    autoComplete="off" />
                                            </div>
                                        </div>
                                    }
                                    <div className="col-2" >
                                        <div className="open">
                                            <label htmlFor="login-username">Quantity
                                                <span className="text-danger"> * </span>
                                            </label><br/>
                                            <input
                                                    className="form-control"
                                                type="text"
                                                maxLength={3}
                                                style={{ maxWidth: 160 }}
                                                onKeyPress={(e) => handleKeyPress(e)}
                                                value={element.used_stock}
                                                placeholder="Quantity"
                                                onChange={(e) => {
                                                    let value = e.target.value ? parseInt(e.target.value) : 0;
                                                    value = value * 1;
                                                    let batchData = [...newBatchData];
                                                    batchData[index].used_stock = value;
                                                    batchData[index].opening_stock = parseInt(batchData[index].free_quantity) + value;
                                                    setNewBatchData(batchData);
                                                }}
                                                autoComplete="off" />
                                        </div>
                                    </div>
                                    <div className="col-2">
                                        <div className="open">
                                            <div className="wrapperRadio">
                                                <br/>
                                                <button
                                                    type="submit"
                                                    onClick={() => saveBatchData(element)}
                                                    className="btn btn-alt-info mb-10 mx-5">
                                                    Select
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                            <div className="open">
                                                <div className="wrapperRadio">
                                                    <br/>
                                                    <button
                                                        type="submit"
                                                        onClick={() => deleteBatchData(index)}
                                                        className="btn btn-alt-info mb-10 mx-5">
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    

                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <button
                type="button"
                style={{ marginLeft: 20 }}
                className="btn btn-alt-primary"
                onClick={() => addNewBatchData()} >
                <i className="fa fa-check mr-5"></i>
                Add more
            </button>
            {
                isLoading && (
                    <Dialog >
                        <div style={{textAlign: 'center'}}>
                            <div style={{marginBottom: '20px'}}><Loader type="infinite-spinner"  /></div>
                            <span>Checking the batch number in the system, please wait...</span>
                        </div>
                    </Dialog>
                )
            }
        </div>
    )
}
export default SelectBatchQuntity